import { Box, Flex } from "@chakra-ui/react";
import colors from "theme/colors";
import TableItemRow from './TabelaItemRow';
import { UnidadeDashboardPessoaMorador } from 'features/unidades/typings/unidade'


interface TableContatosProps {
  data: UnidadeDashboardPessoaMorador | undefined
}
export default function TableContatos({
  data,
}: TableContatosProps) {

 
  return (
    <Box mb={6}>
      <Flex
        bg={colors.black75}
        py={3}
        px={2}
        pl={8}
        fontSize="14px"
        borderBottomColor={colors.black200}
        borderBottomWidth={1}
        borderTopRadius={15}
      >
        <Flex flex={1} fontWeight="bold">Contato</Flex>
        <Flex flex={2} fontWeight="bold">Tipo</Flex>
        
      </Flex>

      {data?.contatos.length ? (
        <>
          {data.contatos.map((contato, index) => (
            <TableItemRow
              bg={index % 2 === 0 ? "white" : colors.black75}

              borderBottomRadius={ index === data?.contatos.length - 1  ? 15 : 0}
              
             id={contato.id}
             contato={contato.conteudo}
             tipo={contato.tipoContatoId}
              receberCobranca={contato.receberCobranca}
            />
          ))}

        </>
      ) : null}
    </Box>
  );
}
